import {LeadEventApiDto, LeadQuoteCommentCreatedEventDataApiDto,} from "../../../api/model/rest";
import LeadEvent, {LeadEventTypeEnum} from "./LeadEvent";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import moment = require("moment");

export default class LeadQuoteCommentCreatedEvent extends LeadEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} leadId lead id.
	 * @param {LeadEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber lead reference number.
	 * @param data lead quote comment data
	 */
	constructor(public readonly id: string,
		public readonly leadId: string,
		public readonly type: LeadEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: LeadQuoteCommentCreatedEventData) {
		super(id, leadId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: LeadEventApiDto): LeadQuoteCommentCreatedEvent {
		const data = LeadQuoteCommentCreatedEventData.fromJson(json.data as LeadQuoteCommentCreatedEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new LeadQuoteCommentCreatedEvent(json.id,
			json.leadId,
			LeadEventTypeEnum.QuoteCommentCreated,
			entity,
			moment(json.createdAt),
			json.referenceNumber,
			data);
	}

	getActivityAdditionalMessages(): string[] {
		return [this.data.commentText, this.data.jobTypeName];
	}

	getActivityType(): string {
		return `QUOTE ${this.data.quoteNumber}${this.data.versionNumber > 1 ? ` v${this.data.versionNumber}` : ""}`
	}

	getActivityMessage(): string {
		return "Comment added";
	}

}

export class LeadQuoteCommentCreatedEventData {
	constructor(public readonly quoteId: string,
		public readonly quoteNumber: number,
		public readonly contactId: string,
		public readonly commentId: string,
		public readonly commentText: string,
		public readonly jobTypeName: string,
		public readonly jobTypeId: string,
		public readonly versionNumber: number
	) {}

	public static fromJson(json: LeadQuoteCommentCreatedEventDataApiDto): LeadQuoteCommentCreatedEventData {
		return new LeadQuoteCommentCreatedEventData(json.quoteId, json.quoteNumber, json.contactId, json.commentId,
			json.commentText, json.jobTypeName, json.jobTypeId, json.versionNumber);
	}
}
